import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-afb4efd2")

_pushScopeId("data-v-afb4efd2")
const _hoisted_1 = { class: "shell padding30px" }
const _hoisted_2 = { class: "detail-title" }
const _hoisted_3 = { class: "float-right" }
const _hoisted_4 = { class: "detail-label" }
const _hoisted_5 = { class: "detail-label" }
const _hoisted_6 = { class: "detail-label" }
const _hoisted_7 = { class: "detail-label" }
const _hoisted_8 = { class: "detail-label" }
const _hoisted_9 = { class: "detail-label" }
const _hoisted_10 = { class: "detail-label" }
const _hoisted_11 = { class: "detail-label" }
const _hoisted_12 = { class: "detail-label" }
const _hoisted_13 = { class: "detail-label" }
const _hoisted_14 = { class: "detail-label" }
const _hoisted_15 = { class: "detail-label" }
const _hoisted_16 = { class: "detail-label" }
const _hoisted_17 = { class: "detail-label" }
const _hoisted_18 = { class: "detail-label" }
const _hoisted_19 = { class: "detail-label" }
const _hoisted_20 = { class: "detail-label" }
const _hoisted_21 = { class: "detail-label" }
const _hoisted_22 = { class: "detail-label" }
const _hoisted_23 = { class: "detail-label" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_27 = { class: "detail-title" }
const _hoisted_28 = { class: "detail-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_list = _resolveComponent("list")
  const _component_user_dialog = _resolveComponent("user-dialog")
  const _component_billing_information = _resolveComponent("billing-information")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("b", _hoisted_2, _toDisplayString(_ctx.$wordList.PersonuserFamilyMaster) + " " + _toDisplayString(_ctx.userInfo.FamilyMaster), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_cus_button, {
          type: "default",
          onClick: _ctx.getBillingInfo
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.OrderBillingInformation), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        ((_ctx.userInfo.Role === '10' || _ctx.userInfo.Role === '20')
                    && _ctx.grade === '1' && _ctx.userInfo.Active === '0')
          ? (_openBlock(), _createBlock(_component_cus_button, {
              key: 0,
              class: "margin-left10px",
              onClick: _ctx.activeUser
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.RDeviceListTanleActive), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        ((_ctx.userInfo.Role === '10' || _ctx.userInfo.Role === '20')
                    && _ctx.grade === '1')
          ? (_openBlock(), _createBlock(_component_cus_button, {
              key: 1,
              class: "margin-left10px",
              type: "blue",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowCnfDialog = true))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.NavInHtmlMenuSet), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.TabelPersonUserInHtmlName) + ":", 1),
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.userInfo.Name), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextFamilySIPNumber) + ":", 1),
      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.userInfo.SipGroup), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.ProperAllTextPersonalSIPNumber) + ":", 1),
      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.userInfo.Account), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$wordList.TabelPropertyManageEmail) + ":", 1),
      _createVNode("label", _hoisted_11, _toDisplayString(_ctx.userInfo.Email), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$wordList.ProperAllTextMobileNumber) + ":", 1),
      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.userInfo.MobileNumber), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$wordList.ProperAllTextInstaller) + ":", 1),
      _createVNode("label", _hoisted_15, _toDisplayString(_ctx.userInfo.Installer), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$wordList.PersonuserFamilyMaster) + ":", 1),
      _createVNode("label", _hoisted_17, _toDisplayString(_ctx.userInfo.FamilyMaster), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$wordList.TabelPersonUserInHtmlPhone) + ":", 1),
      _createVNode("label", _hoisted_19, _toDisplayString(_ctx.userInfo.Phone), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$wordList.TabelMessageBoxCreateTime) + ":", 1),
      _createVNode("label", _hoisted_21, _toDisplayString(_ctx.userInfo.CreateTime), 1)
    ]),
    _createVNode("div", null, [
      _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$wordList.TabelExpretimeBoxSpecificTime) + ":", 1),
      _createVNode("label", _hoisted_23, _toDisplayString(_ctx.userInfo.ExpireTime), 1)
    ]),
    _hoisted_24,
    _hoisted_25,
    _hoisted_26,
    _createVNode("b", _hoisted_27, _toDisplayString(_ctx.$wordList.OrderDevice), 1),
    _createVNode(_component_list, {
      headers: _ctx.deviceHeaders,
      showCheck: false,
      action: false,
      requestData: _ctx.devRequestData
    }, null, 8, ["headers", "requestData"]),
    _createVNode("b", _hoisted_28, _toDisplayString(_ctx.$wordList.OrderApp), 1),
    _createVNode(_component_list, {
      headers: _ctx.userHeaders,
      showCheck: false,
      action: false,
      requestData: _ctx.userRequestData
    }, null, 8, ["headers", "requestData"]),
    (_ctx.isShowCnfDialog)
      ? (_openBlock(), _createBlock(_component_user_dialog, {
          key: 0,
          id: _ctx.id,
          expireTime: _ctx.userInfo.ExpireTime,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowCnfDialog=false)),
          onSuccess: _ctx.getInfo
        }, null, 8, ["id", "expireTime", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.isShowBillInfo)
      ? (_openBlock(), _createBlock(_component_billing_information, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowBillInfo=false)),
          "user-id": _ctx.id
        }, null, 8, ["user-id"]))
      : _createCommentVNode("", true)
  ]))
})